var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.noticeShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "noticeRealTime" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n               " +
                _vm._s(_vm.$t("language.popup.taskListPopup.deleteTask")) +
                "\n               "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.noticeShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "notice-body" }, [
            _c("div", { staticClass: "notice-info" }, [
              _vm._v(
                "\n                       " +
                  _vm._s(_vm.$t("language.cloudSync.realTimeNotice")) +
                  "\n                 "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "realtime-notice-bottom" }, [
              _c(
                "button",
                {
                  staticStyle: { width: "110Px", marginRight: "10Px" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.runTasK()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("language.common.ok")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "cancel-button",
                  on: {
                    click: function($event) {
                      _vm.noticeShow = false
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("language.twoStepverification.cancel"))
                  )
                ]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56c47c98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c47c98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_transfer_popups/realtime_notice_popup.vue
// module id = null
// module chunks = 